import * as swal from 'sweetalert';
import * as _ from 'lodash';
import * as moment from 'moment';
import {AccountService} from "../../../account/core/services/AccountService"
import {DatasetService, IDatasetService} from "../../core/services/DatasetService";
import { AnyAaaaRecord } from 'dns';
export class DashboardPageComponent implements ng.IComponentOptions {
  public controller: any = DashboardController;
  public template: string = /*html*/`
    <div class="container container-fluid padding-2">
      <div class="row">
        <div class="col-md-9 col-sm-12 pull-md-right">
        <breadcrumb tree="$ctrl.tree"></breadcrumb>
        </div>
        <div class="col-md-3 col-sm-12 pull-md-left">
        <div class="panel panel-default">
        <div class="panel-heading"><i class="fa fa-fw fa-user"></i>&nbsp;Your Profile</div>
        <div class="panel-body">
          <p>{{$ctrl.account.fullname}}</p>
          <p><i class="fa fa-phone fa-fw"></i>&nbsp;{{$ctrl.account.contact}}</p>
          <p><i class="fa fa-envelope fa-fw"></i>&nbsp;{{$ctrl.account.email}}</p>
          <p ng-show="$ctrl.account.ministry||$ctrl.account.agency"><i class="fa fa-database fa-fw"></i>&nbsp;{{$ctrl.account.agency.display_name}}<br />
          {{$ctrl.account.ministry.display_name}}
          </p>
        </div>
        <div class="panel-footer clearfix">
          <a href="#/profile" class="btn btn-success btn-sm btn-block">
            <i class="fa fa-pencil"></i> Update
          </a>
        </div>
        </div>
        </div>
        <div class="col-md-9 pull-md-right main-content">
          <div class="tiles clearfix">
            <div class="row">
            <div class="col-md-6">
            <h4 style="font-weight:700;color:#3e6990"><i class="fa fa-fw fa-file-text-o" style="padding-right: 4px"></i>Raw Dataset Summary</h4>
            </div>
            <div class="col-md-6">
            <ui-select ng-model="$ctrl.agency"
              ng-if="$ctrl.account.isAdmin"
              theme="bootstrap"
              ng-change="$ctrl.loadData($ctrl.agency)"
              title="Select an agency">
              <ui-select-match placeholder="Filter By Agency..." allow-clear="true">{{$select.selected.name}}</ui-select-match>
              <ui-select-choices repeat="agency in $ctrl.agencies track by $index">
                <div ng-bind-html="agency.name | highlight: $select.search"></div>
              </ui-select-choices>
            </ui-select>
            </div>
            </div>
            <div class="row row-eq-height">
              <div class="col-sm-4 col-xs-12 tile" style="display:flex;">
                <a ng-click="$ctrl.go('raw')" style="display:flex;flex-direction:column;flex:1;justify-content:flex-end;">
                  <div class="icon icon-lg"><i class="fa fa-cubes color-purple"></i></div>
                  <div>
                  <div class="stat">{{$ctrl.stats.total}}</div>
                  <div class="title">Total</div>
                  <div class="highlight bg-color-purple"></div>
                  </div>
                </a>
              </div>
              <div class="col-sm-8 col-xs-12">
                <div class="row row-eq-height">
                  <div class="col-xs-6 tile">
                  <a ng-click="$ctrl.go('unprocessed')">
								  	<div class="icon"><i class="fa fa-files-o color-magenta"></i></div>
								  	<div class="stat">{{$ctrl.stats.unprocessed}}</div>
								  	<div class="title">Unprocess</div>
								  	<div class="highlight bg-color-magenta"></div>
								  </a>
                  </div>
                  <div class="col-xs-6 tile">
                  <a ng-click="$ctrl.go('pending')">
                    <div class="icon"><i class="fa fa-check-square color-orange"></i></div>
                    <div class="stat">{{$ctrl.stats.pending}}</div>
                    <div class="title">Pending Review</div>
                    <div class="highlight bg-color-orange"></div>
                    <div class="sub-title">Datasets upload via API/SSH/SCP/FTP</div>
                  </a>
                  </div>
                </div>
                <div class="row row-eq-height b-top">
                  <div class="col-xs-6 tile">
                    <a ng-click="$ctrl.go('processed')">
								    	<div class="icon"><i class="fa fa-flag-checkered color-green"></i></div>
								    	<div class="stat">{{$ctrl.stats.processed_success}}</div>
								    	<div class="title">Process Success</div>
								    	<div class="highlight bg-color-green"></div>
								    </a>
                  </div>
                  <div class="col-xs-6 tile">
                    <a ng-click="$ctrl.go('bad')">
                      <div class="icon"><i class="fa fa-bug color-red"></i></div>
                      <div class="stat">{{$ctrl.stats.bad}}</div>
                      <div class="title">Process Failed</div>
                      <div class="highlight bg-color-red"></div>
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <h4 style="font-weight:700;margin-top:32px;color:#3e6990"><i class="fa fa-fw fa-bar-chart" style="padding-right:4px;"></i>Output Summary</h4>
						<div class="row">
							<div class="col-sm-4 col-xs-6 tile">
                <a ng-click="$ctrl.go('public')">
                  <div class="icon"><i class="fa fa-rss color-yellow"></i></div>
                  <div class="stat">{{$ctrl.stats.published_public}}</div>
                  <div class="title">Published Statistic</div>
                  <div class="highlight bg-color-yellow"></div>
                  <div class="sub-title">Shared with everyone</div>
                </a>
							</div>
							<div class="col-sm-4 col-xs-6 tile">
                <a ng-click="$ctrl.go('internal')">
                  <div class="icon"><i class="fa fa-share-square color-blue"></i></div>
                  <div class="stat">{{$ctrl.stats.published_internal}}</div>
                  <div class="title">Cleansed Datasets</div>
                  <div class="highlight bg-color-blue"></div>
                  <div class="sub-title">Shared with all data provider</div>
                </a>
							</div>
              <div class="col-sm-4 col-xs-6 tile">
                <a ng-click="$ctrl.go('other')">
                  <div class="icon"><i class="fa fa-eye-slash color-turquoise"></i></div>
                  <div class="stat">{{$ctrl.stats.not_shared}}</div>
                  <div class="title">Cleansed Datasets</div>
                  <div class="highlight bg-color-turquoise"></div>
                  <div class="sub-title">Not shared</div>
                </a>
							</div>
						</div>
					</div>
					<div class="home-panels">
						<div class="row">
                <div class="col-xs-12">
                  <h4 style="font-weight:700;margin-top:32px;color:#3e6990"><i class="fa fa-fw fa-cube"></i>Dataset Update</h4>
                </div>
							 <div class="col-sm-6">
								<div class="panel panel-default panel-top-color-blue">
									<div class="panel-heading">
										<h3 class="panel-title">
											<div class="pull-right">
												<a ng-click="$ctrl.go('raw')" class="btn btn-default bg-color-blue btn-xs">
													<i class="fa fa-plus"></i> View more
												</a>
											</div>
											<i class="fa fa-cube"></i>&nbsp;Latest Upload Datasets</h3>
									</div>
                  <div class="panel-body">
										<div class="list-group">
											<div class="list-group-item" ng-repeat="dataset in $ctrl.latest|limitTo:3">
												<h4 class="list-group-item-heading font-size-14"><strong>&nbsp;&nbsp;<i class="fa fa-calendar"></i>&nbsp;{{dataset.updatedOn||dataset.createdOn|date:'dd-MM-yyyy'}}</strong><span class="data-category">{{dataset.datatype.category}}</span></h4>
												<p class="list-group-item-text font-size-12">
													{{dataset.display_name|uppercase}}<br/>
                          by {{dataset.agency.display_name||dataset.ministry.display_name}}
												</p>
											</div>
										</div>
									</div>
									<div class="panel-footer"></div>
								</div>
								<div class="panel panel-default panel-top-color-green">
									<div class="panel-heading">
										<h3 class="panel-title">
											<div class="pull-right">
												<a ng-click="$ctrl.go('published')" class="btn btn-default bg-color-green btn-xs">
													<i class="fa fa-plus"></i>&nbsp; View more
												</a>
											</div>
											<i class="fa fa-rss"></i>&nbsp;Latest Publish Output</h3>
									</div>
                  <div class="panel-body">
										<div class="list-group">
											<div class="list-group-item" ng-repeat="dataset in $ctrl.published|limitTo:3">
												<h4 class="list-group-item-heading font-size-14"><strong>&nbsp;&nbsp;<i class="fa fa-calendar"></i>&nbsp;{{dataset.updatedOn||dataset.createdOn|date:'dd-MM-yyyy'}}</strong><span class="data-category">{{dataset.datatype.category}}</span></h4>
												<p class="list-group-item-text font-size-12">
													{{dataset.display_name|uppercase}}<br/>
                          by {{dataset.agency.display_name||dataset.ministry.display_name}}
												</p>
											</div>
										</div>
									</div>
									<div class="panel-footer"></div>
								</div>
							 </div>
							 <div class="col-sm-6">
								<div class="panel panel-default panel-top-color-magenta">
									<div class="panel-heading">
										<h3 class="panel-title">
											<div class="pull-right">
												<a ng-hide="true" ng-href="#/search?sort=L&quality=bad{{$ctrl.account.isAdmin?'':'&owner=o'}}" class="btn btn-default bg-color-magenta btn-xs">
													<i class="fa fa-plus"></i>&nbsp;View more
												</a>
											</div>
											<i class="fa fa-bell"></i>&nbsp;Due for Submission</h3>
									</div>
                    <div class="panel-body">
										<div class="list-group">
											<div class="list-group-item" ng-repeat="submission in $ctrl.submission|limitTo:3">
												<h4 class="list-group-item-heading font-size-14"><strong>&nbsp;&nbsp;<i class="fa fa-calendar"></i>&nbsp;{{submission.next_due|date:'dd-MM-yyyy'}}</strong><span class="data-category">{{submission.datatype.category}}</span></h4>
												<p class="list-group-item-text font-size-12">
													{{submission.datatype.display_name}}<br/>
                          by {{submission.group.value.display_name}}
												</p>
											</div>

										</div>
									</div>
									<div class="panel-footer"></div>
								</div>
								<div class="panel panel-default panel-top-color-red">
									<div class="panel-heading">
										<h3 class="panel-title">
											<div class="pull-right">
												<a ng-click="$ctrl.go('bad')" class="btn btn-default bg-color-red btn-xs">
													<i class="fa fa-plus"></i> View more
												</a>
											</div>
											<i class="fa fa-bug"></i>&nbsp;Bad Quality Datasets</h3>
									</div>
                    <div class="panel-body">
										<div class="list-group">
											<div class="list-group-item" ng-repeat="dataset in $ctrl.bad|limitTo:3">
												<h4 class="list-group-item-heading font-size-14"><strong>&nbsp;&nbsp;<i class="fa fa-calendar"></i>&nbsp;{{dataset.updatedOn||dataset.createdOn|date:'dd-MM-yyyy'}}</strong></h4>
												<p class="list-group-item-text font-size-12">
													{{dataset.display_name|uppercase}}
												</p>
											</div>
										</div>
									</div>
									<div class="panel-footer"></div>
								</div>
							 </div>
						</div>
					</div>
				</div>

      </div>

    </div>
  `;
}

export class DashboardController {
  public static $inject: Array<string> = ["AccountService", "$location", "$http", "$state","$anchorScroll"];
  public stats: any;
  public latest: Array<any>;
  public published: Array<any>;
  public bad: Array<any>;
  public isAdmin: boolean;
  public submission: Array<any>;
  public tree: Array<any>;
  public agencies: any[];
  public agency: any;
  constructor(public account: AccountService, private $location: ng.ILocationService, private $http: ng.IHttpService, private $state:ng.ui.IStateService, private $anchorScroll: ng.IAnchorScrollService) {
    account.$promise.then(() => {
      this.loadData()
    })
    this.tree = [
      {name: "Dashboard", path: "/#dashboard"}
    ];
  }
  public $onInit() {
    this.$anchorScroll();
    const agency = this.$http.get(`${BASE}/api/agency`)
    const ministry = this.$http.get(`${BASE}/api/ministry`)
    Promise.all([agency, ministry]).then(res => {
      const agency = _.map(res[0].data as any, (agency:any) => ({
        name: agency.display_name,
        type: 'agency',
        id: agency._id
      }))
      const ministry = _.map(res[1].data as any, (agency:any) => ({
        name: agency.display_name,
        type: 'ministry',
        id: agency._id
      }))
      this.agencies = _.orderBy(_.union(agency, ministry), ['type', 'name'], ['desc', 'asc'])
    })
  }
  public loadData(agency?) {
    let url
    if (agency) {
      if (agency.type === 'agency')
        url = `${BASE}/api/reports?agency=${agency.id}`
      else if (agency.type === 'ministry')
        url = `${BASE}/api/reports?ministry=${agency.id}`
    }
    else {
      url = `${BASE}/api/reports`
    }
    this.$http.get(url)
    .then((d:any) => {
      if (d && d.data)
        this.stats = d.data;
      else
        this.stats = {
          total: 0,
          unprocessed: 0,
          published: 0,
          bad: 0
        }
    })
    let _query: any = {sort: 'L', type: 'raw'};
    if (!this.account.isAdmin)
      _query.internalOnly = true;
    this.$http.get(`${BASE}/api/search?q=${encodeURIComponent(JSON.stringify(_query))}`)
    .then((d:any) => {
      this.latest = d.data.result;
    })
    this.$http.get(`${BASE}/api/search?q=${encodeURIComponent(JSON.stringify({..._query, published: true}))}`)
    .then((d:any) => {
      this.published = d.data.result;
    })
    this.$http.get(`${BASE}/api/search?q=${encodeURIComponent(JSON.stringify({..._query, quality: 'poor'}))}`)
    .then((d:any) => {
      this.bad = d.data.result;
    })
    if (this.account.isAdmin)
      this.$http.get(`${BASE}api/submission?offset=0&limit=2&sort=D`)
      .then((d:any) => {
        this.submission = d.data.result;
      })
    else {
      let _datatype;
      this.submission = [];
      if (this.account.agency)
        _datatype = this.account.agency.datatypes;
      else if (this.account.ministry)
        _datatype = this.account.ministry.datatypes;
      _.each(_datatype, (dt) => {
        this.$http.get(`${BASE}/api/submission/${dt._id}`)
        .then((d:any) => {
          if(d.data && moment(d.data.next_due).diff(moment(), 'days') <= 30)
            this.submission.push(d.data);
        })
      })
    }
  }
  public go(type) {
    switch(type) {
      case "raw":
      if (this.account.isAdmin)
        this.$state.go("search", {type: 'raw', private: true});
      else
        this.$state.go("mydataset", {type: 'raw', private: true});
      break;
      case "unprocessed":
      if (this.account.isAdmin)
        this.$state.go("search", {processed: false, type: 'raw', private: true});
      else
        this.$state.go("mydataset", {processed: false, type: 'raw', private: true});
      break;
      case "processed":
      if (this.account.isAdmin)
        this.$state.go("search", {processed: true, type: 'raw', private: true, quality: '!poor'});
      else
        this.$state.go("mydataset", {processed: true, type: 'raw', private: true, quality: '!poor'});
      break;
      case "public":
      if (this.account.isAdmin)
        this.$state.go("search", {published: true, private: false, internal: false,  type: 'aggregate'});
      else
        this.$state.go("mydataset", {published: true, private: false, internal: false, type: 'aggregate'});
      break;
      case "internal":
      if (this.account.isAdmin)
        this.$state.go("search", {internal: true, type: 'cleansed' });
      else
        this.$state.go("mydataset", {internal: true, type: 'cleansed' });
      break;
      case "pending":
      if (this.account.isAdmin)
        this.$state.go("search", {pending: true });
      else
        this.$state.go("mydataset", {pending: true });
      break;
      case "other":
      if (this.account.isAdmin)
        this.$state.go("search", {private: true, type: 'cleansed' });
      else
        this.$state.go("mydataset", {private: true, type: 'cleansed' });
      break;
      case "bad":
      if (this.account.isAdmin)
        this.$state.go("search", {quality:'poor', private: true});
      else
        this.$state.go("mydataset", {quality: 'poor', private: true});
      break;
    }
  }
}
